import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SettingsService } from './service';
import { ISettingsState } from './types';
import { tap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { IPagination, IUser } from '../../../../modules/authorization/store/types';
import { checkSovereignEmail } from 'src/app/utils/helpers/helpers';
import { SetCurrentTab, SetFiltersBasedOnTab, SetSearchField } from 'src/app/modules/logged/settings/store/actions';

const defaults: ISettingsState = {
    isLoading: null,
    currentTab: null,
    searchField: '',
    generalUsersFilters: {
        page: 1,
        results: 100,
        sort: ''
    },
    generalUsers: null
};

@State<ISettingsState>({
    name: 'settings',
    defaults
})
@Injectable()
export class SettingsState {

    @Selector()
    static isLoading(state: ISettingsState) {
        return state.isLoading;
    }

    @Selector()
    static currentTab(state: ISettingsState) {
        return state.currentTab;
    }

    @Selector()
    static searchField(state: ISettingsState) {
        return state.searchField;
    }

    @Selector()
    static generalUsersFilters(state: ISettingsState) {
        return state.generalUsersFilters;
    }

    @Selector()
    static generalUsers(state: ISettingsState) {
        return state.generalUsers;
    }

    constructor(private settingsService: SettingsService) { }

    @Action(SetCurrentTab)
    SetCurrentTab(ctx: StateContext<ISettingsState>, action: SetCurrentTab) {
        const state = ctx.getState();
        ctx.patchState({ currentTab: action.tab || state.currentTab || 'GENERAL' });
        ctx.dispatch(new SetFiltersBasedOnTab({ page: 1, ...action.filters }));
    }

    @Action(SetSearchField)
    SetSearchField(ctx: StateContext<ISettingsState>, action: SetSearchField) {
        ctx.patchState({ searchField: action.value });
        ctx.dispatch(new SetFiltersBasedOnTab({ page: 1 }));
    }

    @Action(SetFiltersBasedOnTab)
    SetFiltersBasedOnTab(ctx: StateContext<ISettingsState>, action: SetFiltersBasedOnTab) {
        let state = ctx.getState();
        ctx.patchState({ isLoading: true });
        switch (state.currentTab) {
            default:
                ctx.patchState({
                    generalUsersFilters: {
                        ...state.generalUsersFilters,
                        ...action.filters
                    }
                });
                state = ctx.getState();
                return this.settingsService.fetchAll({ ...state.generalUsersFilters, search: state.searchField })
                    .pipe(tap((pagination: IPagination<IUser>) => {
                        const filteredUsers = {
                            ...pagination,
                            results: pagination.results.filter((user: IUser) => !checkSovereignEmail(user.email))
                        }
                        ctx.patchState({ generalUsers: filteredUsers, isLoading: false });
                    }));
        }
    }

}
